import React from "react";
import { Container, Row, Col, Card, ListGroup, Image } from "react-bootstrap";
import { useTranslation } from "react-i18next";

// import screenshots (replace with actual paths when available)
import activateImg1 from "../../assets/img/docs/activate-1.png";
import activateImg2 from "../../assets/img/docs/activate-2.png";
import activateImg3 from "../../assets/img/docs/activate-3.png";
import suspend1 from "../../assets/img/docs/suspend-1.png";
import suspend2 from "../../assets/img/docs/suspend-2.png";
import resume1 from "../../assets/img/docs/resume-1.png";
import resume2 from "../../assets/img/docs/resume-2.png";
import terminate1 from "../../assets/img/docs/terminate-1.png";
import terminate2 from "../../assets/img/docs/terminate-2.png";
import terminate3 from "../../assets/img/docs/terminate-3.png";
import modify1 from "../../assets/img/docs/modify-1.png";
import modify2 from "../../assets/img/docs/modify-2.png";

const SimProvisioning = () => {
  const { t } = useTranslation();

  const actions = [
    {
      key: "activate",
      images: [activateImg1, activateImg2, activateImg3],
      details: (
        <>
          <p>
            {t(
              "documentation.simCards.simProvisioning.actions.activate.details.intro"
            )}
          </p>
          <ol>
            <li>
              {t(
                "documentation.simCards.simProvisioning.actions.activate.details.steps.0"
              )}
            </li>
            <li>
              {t(
                "documentation.simCards.simProvisioning.actions.activate.details.steps.1"
              )}
            </li>
            <li>
              {t(
                "documentation.simCards.simProvisioning.actions.activate.details.steps.2"
              )}
            </li>
          </ol>
          <p className="text-danger fw-bold">
            {t(
              "documentation.simCards.simProvisioning.actions.activate.details.important"
            )}
          </p>
          <p>
            {t(
              "documentation.simCards.simProvisioning.actions.activate.details.closing"
            )}
          </p>
        </>
      ),
    },
    {
      key: "suspend",
      images: [suspend1, suspend2],
      details: (
        <>
          <p>
            {t(
              "documentation.simCards.simProvisioning.actions.suspend.details.intro"
            )}
          </p>
          <ol>
            <li>
              {t(
                "documentation.simCards.simProvisioning.actions.suspend.details.steps.0"
              )}
            </li>
            <li>
              {t(
                "documentation.simCards.simProvisioning.actions.suspend.details.steps.1"
              )}
            </li>
            <li>
              {t(
                "documentation.simCards.simProvisioning.actions.suspend.details.steps.2"
              )}
            </li>
          </ol>
          <p className="text-danger fw-bold">
            {t(
              "documentation.simCards.simProvisioning.actions.suspend.details.important"
            )}
          </p>
          <p>
            {t(
              "documentation.simCards.simProvisioning.actions.suspend.details.closing"
            )}
          </p>
        </>
      ),
    },
    {
      key: "resume",
      images: [resume1, resume2],
      details: (
        <>
          <p>
            {t(
              "documentation.simCards.simProvisioning.actions.resume.details.intro"
            )}
          </p>
          <ol>
            <li>
              {t(
                "documentation.simCards.simProvisioning.actions.resume.details.steps.0"
              )}
            </li>
            <li>
              {t(
                "documentation.simCards.simProvisioning.actions.resume.details.steps.1"
              )}
            </li>
            <li>
              {t(
                "documentation.simCards.simProvisioning.actions.resume.details.steps.2"
              )}
            </li>
          </ol>
          <p className="text-danger fw-bold">
            {t(
              "documentation.simCards.simProvisioning.actions.resume.details.important"
            )}
          </p>
          <p>
            {t(
              "documentation.simCards.simProvisioning.actions.resume.details.closing"
            )}
          </p>
        </>
      ),
    },
    {
      key: "terminate",
      images: [terminate1, terminate2, terminate3],
      details: (
        <>
          <p>
            {t(
              "documentation.simCards.simProvisioning.actions.terminate.details.intro"
            )}
          </p>
          <ol>
            <li>
              {t(
                "documentation.simCards.simProvisioning.actions.terminate.details.steps.0"
              )}
            </li>
            <li>
              {t(
                "documentation.simCards.simProvisioning.actions.terminate.details.steps.1"
              )}
            </li>
            <li>
              {t(
                "documentation.simCards.simProvisioning.actions.terminate.details.steps.2"
              )}
            </li>
          </ol>
          <p className="text-danger fw-bold">
            {t(
              "documentation.simCards.simProvisioning.actions.terminate.details.important"
            )}
          </p>
          <p>
            {t(
              "documentation.simCards.simProvisioning.actions.terminate.details.closing"
            )}
          </p>
        </>
      ),
    },
    {
      key: "modify",
      images: [modify1, modify2],
      details: (
        <>
          <p>
            {t(
              "documentation.simCards.simProvisioning.actions.modify.details.intro"
            )}
          </p>
          <ol>
            <li>
              {t(
                "documentation.simCards.simProvisioning.actions.modify.details.steps.0"
              )}
            </li>
          </ol>
          <p className="text-danger fw-bold">
            {t(
              "documentation.simCards.simProvisioning.actions.modify.details.important"
            )}
          </p>
          <p>
            {t(
              "documentation.simCards.simProvisioning.actions.modify.details.closing"
            )}
          </p>
        </>
      ),
    },
  ];

  return (
    <Container fluid className="py-5 sim-provisioning">
      {/* ✅ Introductory card */}
      <Row className="justify-content-center mb-4">
        <Col lg={8}>
          <Card className="shadow-sm border-0 rounded-lg p-4">
            <Card.Body>
              <Card.Title className="display-6 mb-3">
                {t("documentation.simCards.simProvisioning.introduction.title")}
              </Card.Title>
              <Card.Text>
                {t(
                  "documentation.simCards.simProvisioning.introduction.description"
                )}
              </Card.Text>

              {/* ✅ Functionalities List */}
              <ListGroup variant="flush" className="mb-3">
                {actions.map((action) => (
                  <ListGroup.Item key={action.key} className="px-0">
                    <strong>
                      {t(
                        `documentation.simCards.simProvisioning.actions.${action.key}.title`
                      )}
                    </strong>{" "}
                    –{" "}
                    {t(
                      `documentation.simCards.simProvisioning.actions.${action.key}.description`
                    )}
                  </ListGroup.Item>
                ))}
              </ListGroup>

              <Card.Text>
                {t(
                  "documentation.simCards.simProvisioning.introduction.closing"
                )}
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* ✅ Subchapter cards for each action */}
      {actions.map((action) => (
        <Row key={action.key} className="mb-4 justify-content-center">
          <Col lg={10}>
            <Card className="shadow-sm border-0 rounded-lg p-4">
              <Card.Body>
                <Card.Title className="h4 mb-3">
                  {t(
                    `documentation.simCards.simProvisioning.actions.${action.key}.title`
                  )}
                </Card.Title>

                {/* ✅ Action-specific details */}
                {action.details && <div className="mb-3">{action.details}</div>}

                {/* ✅ Optional screenshots */}
                {action.images.length > 0 && (
                  <Row>
                    {action.images.map((img, idx) => (
                      <Col md={6} key={idx} className="mb-3">
                        <Image
                          src={img}
                          alt={`${action.key} screenshot ${idx + 1}`}
                          fluid
                          rounded
                          className="doc-image"
                        />
                      </Col>
                    ))}
                  </Row>
                )}
              </Card.Body>
            </Card>
          </Col>
        </Row>
      ))}
    </Container>
  );
};

export default SimProvisioning;
